import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { ArrowLeftBlack, ArrowRightBlack, CloseIcon } from 'assets/icons';
import { QuoteService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalChangePrice extends React.Component<Props> {

	state = {
		item: this.props.item,
		form: {
			price: this.props.item?.price || ''
		}
	}

	submit = async () => {
		const res: any = await QuoteService.admin.changePrice({
			...this.state.form,
			quote_id: this.props.item?.id
		});
		this.props.onClose();
		Globals.showSuccess("Se ha guardado correctamente el precio de la cotización");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		return (
			<div id="modal-change-price">
				<Input
					type="decimal"
					color="white"
					name="price"
					value={ this.state.form.price }
					placeholder="Precio"
					onChange={ (e: any) => this.change(e) } />
				<div className="row row-buttons">
					<div className="col-md-6 text-center">
						<button className="btn btn-cancel" onClick={ () => this.props.onClose() }>
							Cerrar
						</button>
					</div>
					<div className="col-md-6 text-center">
						<button className="btn btn-submit" onClick={ () => this.submit() }>
							Guardar
						</button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalChangePrice;